module.exports = __webpack_public_path__ + "img/05.28a109ef.png";